import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-display text-xl text-[#e3c988] md:text-2xl">{title}</h2>
    <div className="mt-4 space-y-3 text-base leading-relaxed text-[#c9bda9]">{children}</div>
  </section>
);

export default function LegalLayout({ eyebrow, title, children }) {
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen" data-testid="legal-page">
      <header className="border-b border-[#241a15]">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-5">
          <Link to="/" data-testid="legal-logo-link" className="flex items-center gap-3">
            <img
              src="/images/logo.png"
              alt="Vintage Billard Logo"
              className="h-10 w-10 rounded-full border border-[#c9a24a]/40 object-cover"
            />
            <span className="font-display text-lg text-[#f4ecdd]">Vintage Billard</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[#c9bda9] transition-colors duration-300 hover:text-[#e3c988]"
          >
            <ArrowLeft size={14} /> Zurück zur Startseite
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-6 py-16 md:py-24">
        <p className="text-xs uppercase tracking-[0.22em] text-[#c9a24a]">{eyebrow}</p>
        <h1 className="mt-4 font-display text-4xl font-light text-[#f4ecdd] md:text-5xl">{title}</h1>
        <div className="mt-12 space-y-10">{children}</div>
      </main>
      <footer className="border-t border-[#241a15] px-6 py-8">
        <div className="mx-auto flex max-w-4xl flex-wrap gap-x-8 gap-y-3 text-xs uppercase tracking-[0.18em] text-[#c9bda9]/60">
          <Link to="/" className="transition-colors duration-300 hover:text-[#e3c988]">Startseite</Link>
          <Link to="/impressum" className="transition-colors duration-300 hover:text-[#e3c988]">Impressum</Link>
          <Link to="/datenschutz" className="transition-colors duration-300 hover:text-[#e3c988]">Datenschutz</Link>
          <span className="normal-case tracking-normal">© 2026 Vintage Billard</span>
        </div>
      </footer>
    </div>
  );
}
